import { Button, Typography } from '@mui/material'
import { Navigate, useNavigate } from 'react-router-dom'

import PageWrapper from '/components/page-wrapper'
import StyledPaper from '/components/paper'
import Menu from '/components/statistics/nav-menu'
import HelpText from '/help/statistics-overview'
import { AppContext } from '/providers/app-context'
import { useContext } from 'react'

const sections = [
  {
    title: 'Pass Activity',
    description: 'Review live pass issues, updates and notifications over time to spot busy periods and long-term trends.',
    path: '/statistics/pass-activity'
  },
  {
    title: 'Adoption',
    description: 'Compare issued, active and expired passes, plus Apple and Google installs by template.',
    path: '/statistics/adoption'
  },
  {
    title: 'Template Changes',
    description: 'See when templates are being created and how often they are updated.',
    path: '/statistics/template-changes'
  },
  {
    title: 'Installs',
    description: 'Track Apple and Google install trends to understand when passes are reaching devices.',
    path: '/statistics/installs'
  },
  {
    title: 'Scans',
    description: 'View scan activity over time for the selected client or an individual template.',
    path: '/statistics/scans'
  },
  {
    title: 'Pass Types',
    description: 'See which pass types are most active across your live templates.',
    path: '/statistics/pass-types'
  }
]

const Statistics = () => {
  const navigate = useNavigate()
  const { user } = useContext(AppContext)

  if (user?.permissions.client_admin) return (
    <PageWrapper title="Statistics" HelpText={HelpText} heading="Statistics & Exports" menu={<Menu />}>
      <div className='flex flex-col overflow-y-auto h-full pb-20'>
        <div className='grid grid-cols-1 xl:grid-cols-2 gap-5 mt-5'>
          {sections.map(section => (
            <StyledPaper key={section.path}>
              <div className='p-5 flex flex-col gap-4 h-full'>
                <div className='flex flex-col gap-2'>
                  <Typography variant='h5'>{section.title}</Typography>
                  <Typography variant='body2'>{section.description}</Typography>
                </div>
                <div className='flex justify-end mt-auto'>
                  <Button variant='contained' onClick={() => navigate(section.path)}>Open</Button>
                </div>
              </div>
            </StyledPaper>
          ))}
        </div>
      </div>
    </PageWrapper>
  )
  return <Navigate to="/" replace />
}

export default Statistics
